export default class Line {
    constructor(p1, p2) {
        this.px = p1.x;
        this.py = p1.y;
        this.vx = p2.x - p1.x;
        this.vy = p2.y - p1.y;
    }
    getDistance(point) {
        this.vx -= this.px;
        this.vy -= this.py;
        return this.vx == 0 ? this.vy > 0 ? point.x - this.px : this.px - point.x
            : this.vy == 0 ? this.vx < 0 ? point.y - this.py : this.py - point.y
                : ((point.x - this.px) * this.vy - (point.y - this.py) * this.vx) / Math.sqrt(this.vx * this.vx + this.vy * this.vy);
    }
}
//# sourceMappingURL=line.js.map